// import Cookies from 'js-cookie'

// const TokenKey = 'admin-token'

export function getUserInfo () {
  var userInfo = sessionStorage.getItem('userInfo')
  if (userInfo != null) {
    try {
      userInfo = JSON.parse(userInfo)
      return userInfo
    } catch (error) {
      return null
    }
  } else {
    return null
  }
}

export function getToken () {
  var userInfo = sessionStorage.getItem('userInfo')
  if (userInfo != null) {
    try {
      userInfo = JSON.parse(userInfo)
      return userInfo.token
    } catch (error) {
      return null
    }
  } else {
    return null
  }
}

export function setUserInfo (userInfo) {
  sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
}

export function removeUserInfo () {
  return sessionStorage.setItem('userInfo', null)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js